import React, { useState } from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import { DocumentTextIcon } from "@heroicons/react/24/outline";
import { useLanguage } from "../contexts/LanguageContext";
import ContractLists from "components/contracts/ContractLists";
import { useAuth } from "contexts/AuthContext";
import DocumentGeneratorModal from "components/documents/DocumentGeneratorModal";
import { useContracts } from "hooks/useContracts";
import CommonPageHeader from "../components/common/CommonPageHeader";

const Contracts = () => {
  const { t } = useLanguage();
  const { user } = useAuth();
  const { refreshContracts } = useContracts();
  const [isGeneratorModalOpen, setIsGeneratorModalOpen] = useState(false);

  const handleCloseGeneratorModal = () => {
    setIsGeneratorModalOpen(false);
    // Refresh the contracts list when the modal is closed
    refreshContracts();
  };

  return (
    <div className="space-y-3 sm:space-y-4 pb-4">
      <CommonPageHeader
        title={t("contracts.title")}
        subtitle="Szerződések kezelése és áttekintése"
        icon={DocumentTextIcon}
      >
        {user?.role !== 'user' && (
          <button
            onClick={() => setIsGeneratorModalOpen(true)}
            className="bg-white/20 backdrop-blur-sm text-white px-3 py-2 rounded-md text-sm flex items-center justify-center hover:bg-white/30 transition-colors"
          >
            <PlusIcon className="h-4 w-4 mr-2" />
            <span>{t("contracts.newContract")}</span>
          </button>
        )}
      </CommonPageHeader>

      {/* Contracts list */}
      <ContractLists />

      {/* Document Generator Modal */}
      <DocumentGeneratorModal
        isOpen={isGeneratorModalOpen}
        onClose={handleCloseGeneratorModal}
        documentDataProvider={null}
        forceContractTemplates={true}
      />
    </div>
  );
};

export default Contracts;

